import type { MessageKey } from "./ru"

export const plMessages = {
  "common.loading": "Ładowanie...",
  "common.error": "Błąd",
  "common.back": "Wstecz",
  "common.next": "Dalej",
  "common.search": "Szukaj",
  "auth.loginErrorTitle": "Błąd logowania",
  "auth.openViaTelegram": "Otwórz aplikację przez Telegram",
  "auth.telegramRequired": "Aplikację należy otworzyć przez Telegram",
  "auth.authorizationError": "Błąd autoryzacji",
  "device.rotatePortrait": "Obróć urządzenie do orientacji pionowej",
  "country.brazil": "Brazylia",
  "country.vietnam": "Wietnam",
  "country.egypt": "Egipt",
  "country.india": "Indie",
  "country.indonesia": "Indonezja",
  "country.iran": "Iran",
  "country.spain": "Hiszpania",
  "country.italy": "Włochy",
  "country.kazakhstan": "Kazachstan",
  "country.colombia": "Kolumbia",
  "country.malaysia": "Malezja",
  "country.mexico": "Meksyk",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Rosja",
  "country.usa": "Stany Zjednoczone",
  "country.turkey": "Turcja",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraina",
  "country.philippines": "Filipiny",
  "countrySelection.chooseCountry": "Wybierz kraj",
  "countrySelection.openAria": "Wybierz kraj",
  "languageSelection.chooseLanguage": "Wybierz język",
  "commercial.direction.autotrade": "Auto Market",
  "commercial.direction.insurance": "Ubezpieczenie",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Pomoc drogowa",
  "commercial.searchLabel": "Wyszukiwanie BeepApp",
  "commercial.cityPlaceholder": "Wpisz miasto",
  "commercial.emptyTitle": "Brak ofert na dziś",
  "commercial.emptyLine1": "W Twoim mieście nie ma jeszcze aktywnych partnerów BeepApp",
  "commercial.emptyLine2": "Już pracujemy nad ich znalezieniem i podłączeniem",
  "commercial.emptyLine3": "Nowe oferty pojawią się tutaj automatycznie",
  "commercial.helperLine1": "Wpisz swoje miasto, aby zobaczyć",
  "commercial.helperLine2": "dostępne oferty",
  "commercial.partnerPrompt": "Chcesz zostać partnerem BeepApp?",
  "commercial.apply": "Zgłoś się",
  "main.admin": "Admin",
  "main.garage": "Garaż",
  "main.signalSent": "Sygnał wysłany",
  "main.partnerInviteUnavailable": "Zaproszenie partnerskie jest niedostępne",
  "main.enterPlate": "Wpisz numer rejestracyjny",
  "main.searchError": "Błąd wyszukiwania",
  "main.signalSendError": "Nie udało się wysłać sygnału",
  "main.shareCardPrefix": "Karta numeru",
  "main.shareLinkError": "Nie udało się przygotować linku",
  "main.searchByPlateAria": "Szukaj po numerze rejestracyjnym",
  "main.russianPlateAria": "Rosyjski numer rejestracyjny",
  "main.plateAria": "Numer rejestracyjny",
  "main.findPlateAria": "Znajdź numer",
  "main.loadingVehicle": "Ładowanie karty pojazdu…",
  "main.leaveSignal": "Wyślij sygnał",
  "main.share": "Udostępnij",
  "signalSelection.chooseType": "Wybierz typ sygnału",
  "signalSelection.category.attention": "Osobiste",
  "signalSelection.category.road": "Drogowe",
  "signalSelection.category.urgent": "Pilne",
  "signalSelection.chooseSignal": "Wybierz sygnał",
  "signalSelection.suggestOwn": "Zaproponuj własny",
  "signalConfirmation.title": "Potwierdź sygnał",
  "signalConfirmation.plateHeading": "Sprawdź numer rejestracyjny",
  "signalConfirmation.signalHeading": "Sprawdź wybrany sygnał",
  "signalConfirmation.replyTitle": "Zezwól na odpowiedź w Telegramie",
  "signalConfirmation.replyBody": "Włącz tę opcję, aby właściciel numeru mógł\nnapisać do Ciebie w Telegramie. Odpowiedzi są możliwe tylko,\njeśli masz @username. Decyzja o odpowiedzi\nnależy do właściciela numeru.",
  "signalConfirmation.consentText": "Potwierdzam, że ten sygnał dotyczy\nrzeczywistej sytuacji i nie jest spamem\nani fałszywym zgłoszeniem.",
  "signalConfirmation.warning": "Po wysłaniu sygnału\nnie można go zmienić",
  "signalConfirmation.sending": "Wysyłanie…",
  "signalConfirmation.send": "Wyślij",
  "partner.loadingAria": "Ładowanie",
  "partner.title": "Program partnerski",
  "partner.offerLine1": "Zarabiaj 30% ze wszystkich płatności bezterminowo",
  "partner.offerLine2": "dokonywanych przez użytkowników zaproszonych do BeepApp",
  "partner.offerLine3": "przez program afiliacyjny Telegram",
  "partner.connectUnavailable": "Połączenie będzie dostępne po skonfigurowaniu programu afiliacyjnego Telegram.",
  "partner.connectTelegram": "Połącz w Telegramie",
  "partner.qrAria": "Kod QR linku partnerskiego",
  "partner.download": "Pobierz",
  "partner.promoHeading": "Utwórz osobisty kod promocyjny",
  "partner.promoHelperLine1": "Kod promocyjny aktywuje dodatkowy rok subskrypcji",
  "partner.promoHelperLine2": "i pomaga pozyskiwać użytkowników",
  "partner.promoAria": "Kod promocyjny",
  "partner.affiliateHeading": "Twój link afiliacyjny",
  "partner.affiliateHelper": "Zapisz link, aby utworzyć osobisty kod QR",
  "partner.affiliateAria": "Link afiliacyjny",
  "partner.qrNoteLine1": "Kod QR można umieścić na pojeździe,",
  "partner.qrNoteLine2": "w mediach społecznościowych i materiałach reklamowych",
  "partner.save": "Zapisz",
  "partner.reset": "Resetuj",
  "partner.resetConfirm": "Zresetować zapisany link afiliacyjny? Kod promocyjny pozostanie Twój.",
  "partner.promoFormatError": "Kod promocyjny musi mieć od 4 do 15 znaków.",
  "partner.affiliateHostError": "Dozwolone są tylko linki t.me lub telegram.me.",
  "partner.affiliatePathError": "Link nie zawiera ścieżki Telegram.",
  "partner.affiliateFormatError": "Nieprawidłowy link afiliacyjny.",
  "partner.loadError": "Błąd ładowania",
  "partner.checkInputError": "Sprawdź wprowadzone dane",
  "garageActivation.promoInvalid": "Kod promocyjny jest nieprawidłowy",
  "garageActivation.plateOccupied": "Ten numer rejestracyjny jest już powiązany",
  "garageActivation.activateError": "Nie udało się aktywować Garażu",
  "garageEntry.loadJournalError": "Nie udało się załadować dziennika pokładowego",
  "garageEntry.loadStatusesError": "Nie udało się załadować statusów",
  "garageEntry.activationSuccess": "Garaż został aktywowany",
  "garageEntry.plateAttached": "Numer został powiązany",
  "garageEntry.attachError": "Nie udało się powiązać numeru",
  "garageEntry.activationNote": "Aktywuj swój Garaż",
  "garageSheet.activationTitle": "Aktywacja Garażu",
  "garageSheet.plateHelper": "Wpisz numer rejestracyjny pojazdu",
  "garageSheet.promoHelper": "Masz kod promocyjny?",
  "garageSheet.cleanBonusLine1": "Po aktywacji masz 1 godzinę",
  "garageSheet.cleanBonusLine2": "na bezpłatny „Clean Start”",
  "garageSheet.activationFor": "Aktywacja na",
  "garageSheet.cost": "Koszt",
  "garageSheet.ownerConsentLine1": "Potwierdzam, że jestem właścicielem",
  "garageSheet.ownerConsentLine2": "pojazdu o podanym",
  "garageSheet.ownerConsentLine3": "numerze rejestracyjnym.",
  "garageSheet.processing": "Przetwarzanie...",
  "garageSheet.attach": "Powiąż",
  "garageSheet.pay": "Zapłać",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Dezaktywacja Garażu",
  "garageLifecycle.cleanWarningLine1": "Historia numeru zostanie usunięta",
  "garageLifecycle.cleanWarningLine2": "bez możliwości odzyskania!",
  "garageLifecycle.deactivateWarningLine1": "Po dezaktywacji dostęp do aktywnych",
  "garageLifecycle.deactivateWarningLine2": "funkcji Garażu zostanie zakończony",
  "garageLifecycle.willBeDeleted": "ZOSTANIE USUNIĘTE",
  "garageLifecycle.cleanRemovedLine1": "• Wszystkie wpisy z dziennika pokładowego",
  "garageLifecycle.cleanRemovedLine2": "• Historia odebranych sygnałów",
  "garageLifecycle.cleanRemovedLine3": "• Publiczne liczniki sygnałów",
  "garageLifecycle.cleanRemovedLine4": "  na karcie numeru",
  "garageLifecycle.willRemain": "POZOSTANIE",
  "garageLifecycle.cleanPreservedLine1": "• Powiązanie numeru z Garażem",
  "garageLifecycle.cleanPreservedLine2": "• Pozostały okres aktywacji",
  "garageLifecycle.cleanPreservedLine3": "• Wybrany status numeru",
  "garageLifecycle.cleanPreservedLine4": "• Łączna liczba wyświetleń karty",
  "garageLifecycle.freeFirstHour": "Bezpłatnie przez pierwszą godzinę",
  "garageLifecycle.willBecomeUnavailable": "PRZESTANIE BYĆ DOSTĘPNE",
  "garageLifecycle.deactivateRemovedLine1": "• Dziennik pokładowy",
  "garageLifecycle.deactivateRemovedLine2": "• Wybór i używanie statusu numeru",
  "garageLifecycle.deactivateRemovedLine3": "• Automatycznie opuścisz AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Auto Market",
  "garageLifecycle.deactivateRemovedLine5": "• Ubezpieczenie",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Pomoc drogowa",
  "garageLifecycle.deactivateRemovedLine8": "• Numer zostanie odłączony od Garażu",
  "garageLifecycle.willRemainAvailable": "POZOSTANIE DOSTĘPNE",
  "garageLifecycle.deactivatePreservedLine1": "• Towarzysz",
  "garageLifecycle.deactivatePreservedLine2": "• Dyspozytor",
  "garageLifecycle.deactivatePreservedLine3": "• Wyszukiwanie i przeglądanie numeru",
  "garageLifecycle.deactivatePreservedLine4": "  publicznej karty pojazdu",
  "garageLifecycle.deactivatePreservedLine5": "• Możliwość ponownej aktywacji",
  "garageLifecycle.deactivatePreservedLine6": "  Garażu w dowolnym momencie",
  "garageLifecycle.cleanConsentLine1": "Wyrażam zgodę na usunięcie",
  "garageLifecycle.cleanConsentLine2": "całej historii tego numeru",
  "garageLifecycle.cleanConsentLine3": "bez możliwości odzyskania.",
  "garageLifecycle.deactivateConsentLine1": "Potwierdzam dezaktywację i",
  "garageLifecycle.deactivateConsentLine2": "zakończenie dostępu do wszystkich",
  "garageLifecycle.deactivateConsentLine3": "aktywnych funkcji Garażu.",
  "garageLifecycle.clean": "Wyczyść",
  "garageLifecycle.deactivate": "Dezaktywuj",
} satisfies Record<MessageKey, string>
